<script setup>
import { ref, watch } from 'vue';

// Props
const props = defineProps({
    visible: { type: Boolean, default: false },
    dialogHeader: { type: String, default: '' },
    dialogMessage: { type: String, default: '' },
    dialogIcon: { type: String, default: '' },
    dialogWidth: { type: String, default: '350px' },
    dialogButtonSeverity: { type: String, default: '' },
    dialogColor: { type: String, default: '#0038EA' }
});

const emit = defineEmits(['confirm', 'cancel', 'update:visible']);

const displayDialog = ref(props.visible);

watch(
    () => props.visible,
    (newValue) => {
        displayDialog.value = newValue;
    }
);

watch(displayDialog, (newValue) => {
    emit('update:visible', newValue);
});

const closeDialog = () => {
    displayDialog.value = false;
    emit('cancel');
};

const confirmDialog = () => {
    //console.log('Dialog confirmed!');
    emit('confirm');
    closeDialog();
};
</script>

<template>
    <!-- 모달이 표시될 때만 렌더링 -->
    <div v-if="displayDialog" class="fixed inset-0 flex items-center justify-center z-[2000] p-4 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-800 bg-opacity-35 transition-opacity"></div>

        <div class="relative bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
            <div class="sm:flex sm:items-start">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10 opacity-45" :style="{ backgroundColor: props.dialogColor }">
                    <!-- 기존 아이콘 색상   stroke="#0038EA"  -->
                    <svg class="h-6 w-6" stroke="white" fill="none" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        {{ dialogHeader }}
                    </h3>
                    <div class="mt-2">
                        <p class="text-base leading-5 text-gray-700">
                            {{ dialogMessage }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-2 sm:w-auto">
                    <button
                        type="button"
                        @click="closeDialog"
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        취소
                    </button>
                </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button
                        type="button"
                        @click="confirmDialog"
                        :style="{ backgroundColor: props.dialogColor }"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-[#0038EA] text-base leading-6 font-medium text-white shadow-sm hover:bg-[#0026A3] focus:outline-none focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        확인
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>
